import { ErrorResponse } from '@models/error.response';
import { TranslateService } from '@ngx-translate/core';
import { MainComponent } from '../main/main.component';
import { of, from } from 'rxjs';
import { ActionType } from '@type/action.type';
import { AppConstant } from '@constants/app.constant';
import { NgForm } from '@angular/forms';
import { FormValidationUtil } from '@utils/form.validation';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Component, ElementRef, QueryList, ViewChild, ViewChildren } from '@angular/core';
import swal from 'sweetalert2';
import { switchMap, map, flatMap, filter, toArray, mergeMap, reduce } from 'rxjs/operators';
import { User } from '@app/models/user';
import { AdminUserService } from '@app/services/admin-user-service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgSelectUtil } from '@app/utils/ng-select-utils';
import { DefaultOnePageField, OnepageTemplate, OnepageTemplateAdminFieldControl, OnepageTemplateConfig, OnepageTemplateFieldTypeConfig } from '@app/models/onepage-template';
import { OnepageField, FieldType } from '@app/models/onepage-template-field';
import * as FileSaver from 'file-saver';
import { ModulePathConstant } from '@app/constants/modulePath.constant';
import { CommonService } from '@app/services/common.service';
import { MapObjectUtil } from '@app/utils/map-object-util';
import { OnepageTemplateService } from '@app/services/onepage-template.service';
import { UUID } from 'angular2-uuid';
import { HtmlTemplateService } from '@app/services/html-template.service';
import { HtmlTemplate } from '@app/models/html-template';
import { BinaryFile } from '@app/models/binary-file';
import { BinaryFileService } from '@app/services/binary-file.service';
import { UploadOutput } from 'ngx-uploader';
import { ApplicationFile } from '@app/models/application-file';
import { CommonResponse } from '@app/models/common-model';
import { OnepageTemplateConfigService } from '@app/services/onepage-template-config.service';


declare var toastr: any;
const MAX_DOCUMENT_FILE_SIZE: number = 4 * 1024 * 1024;

@Component({
    templateUrl: './onepage-template-config.component.html',
    styleUrls: ['./onepage-template-config.component.scss']
})
export class OnepageTemplateConfigComponent {

    defaultHtmlTemplate: string[];
    fileTypeOptions: string[]=[];

    @ViewChildren(NgSelectComponent) ngSelects: QueryList<NgSelectComponent>;
    selectAll = NgSelectUtil.selectAll
    @ViewChild('workflowForm', { static: false }) workflowForm: NgForm;
    @ViewChild('documentFileSelect', { static: false }) documentFileSelect: ElementRef;
    isFieldError = FormValidationUtil.isFieldError;
    action: ActionType;
    loading: boolean = false;
    clickSave: boolean = false;
    isShowAdd:boolean = false;
    isShowUpdate:boolean = false;
    statusInInit=null;
    isValid2Submit: boolean = true;

    
    htmlTemplateFileOptions: string[]=['designA.png'];
    templateFieldLocationOptions: string[]=['default'];
    record: OnepageTemplateConfig = new OnepageTemplateConfig();
    selectedTemplateFile: any;
    maxFieldSeq = 1;
    imgFile: BinaryFile;
    binaryFileApplication: ApplicationFile;

    constructor(
        private adminUserService: AdminUserService,
        private onepageTemplateConfigService: OnepageTemplateConfigService,
        private htmlTemplateService: HtmlTemplateService,
        private router: Router,
        private route: ActivatedRoute,
        private mainComponent: MainComponent,
        private commonService: CommonService,
        private translate: TranslateService,
        public appConstant: AppConstant,
        protected binaryFileService: BinaryFileService) {
    }

    ngOnInit(): void {
        let companyCode =  this.commonService.getCurrentUser().companyCode;

        this.htmlTemplateService.findByCondition('stratus','ENABLED').subscribe(
            (result: any) => {
              this.defaultHtmlTemplate = [];
              for(var i=0; i<result.length; i++){
                  var htmltemplate = result[i];
                  this.defaultHtmlTemplate.push(htmltemplate.templateName);
              }
          });

          this.htmlTemplateService.getAllFieldType().subscribe(
            result => {
                this.fileTypeOptions = result;
            }
          );
       

        // this.taskTypeOptions = [].concat(this.commonTaskTypeOptions)
        this.route.params
            .pipe(
                switchMap((params: Params) => {
                    this.loading = true;
                    if (params['id'] === 'new') {
                        this.action = 'CREATE';
                        this.isShowAdd = this.commonService.showAddButton(this.action,'PERM_ONEPAGE_TEMPLATE_CREATE');
                    } else {
                        this.action = 'EDIT';
                        this.isShowUpdate = this.commonService.showUpdateButton(this.action,'PERM_ONEPAGE_TEMPLATE_UPDATE');
                    }
                    return of(params);
                }),
                switchMap((params: Params) => {
                    return of(params);
                }),
                switchMap((params: Params) => {
                    if (this.action == 'CREATE') {
                        let form = new OnepageTemplateConfig();
                        // let task = new OnepageField();
                        //  form.onePageFields = [];
                        return of(form);
                    } else {
                        return this.onepageTemplateConfigService.get(params['id'])
                    }
                })
            )
            .subscribe((workflowForm: OnepageTemplateConfig) => {
                this.record = workflowForm;
                // this.statusInInit = this.record.status;
                
                // this.imgFile = this.record.companyTemplateLogoImage;
                 
                
                // if (this.action == 'CREATE') {
                //     this.record.onepageTemplateCode = companyCode+Date.now();
                //     this.record.merCode = companyCode;
                //     this.addTaskByDefault('phone','Phone','PHONE');
                //     this.addTaskByDefault('email','Email','EMAIL');
                //     this.addTaskByDefault('deliveryAddress','Delivery Address','TEXT');
                // }

                // this.htmlTemplateService.findByCondition('stratus','ENABLED').subscribe(
                //     result => {
                //       this.defaultHtmlTemplate = result;
                      
                //         if(!this.record.templateFileName){
                //             this.selectedTemplateFile = this.defaultHtmlTemplate[0].htmlTemplateImage;
                //             this.record.templateFileName = this.defaultHtmlTemplate[0].templateName;
                //             this.templateFieldLocationOptions = this.getLocationList(this.defaultHtmlTemplate[0].locationValue);// ['A','B'];
                //         }else{
                //             var theHtmlTemp = null;
                //             for(var i=0; i<this.defaultHtmlTemplate.length; i++){
                //                 var dp = this.defaultHtmlTemplate[i];
                //                 if(dp.templateName==this.record.templateFileName){
                //                     theHtmlTemp = dp;
                //                     break;
                //                 }
                //             }
                //             if(theHtmlTemp){
                //                 this.selectedTemplateFile = theHtmlTemp.htmlTemplateImage;
                //                 this.templateFieldLocationOptions = this.getLocationList(theHtmlTemp.locationValue);// ['A','B'];
                //             }
                //         }
                        
                //   });

        
       
                // if (this.record.onePageFields && this.record.onePageFields.length > 0) {

                //     if(this.action == 'CREATE'){
                //        this.record.onePageFields.forEach(formTask => {
                //            // formTask.sequence=1;
                //         });
                //     }else if(this.action == 'EDIT'){
                //         this.record.onePageFields.forEach(formTask => {
                //             if(formTask.sequence>this.maxFieldSeq){
                //                 this.maxFieldSeq = formTask.sequence;
                //             }
                //             formTask._uiFlagId = UUID.UUID();
                //         });
                       
                //         this.record.onePageFields.sort(this.compare2);
                //     }
                // }
                // if (this.record.fieldType == 'COMPANY') {
                //     this.taskTypeOptions = this.taskTypeOptions.concat(this.companyTaskTypeOptions);
                // }
                this.loading = false;
            });

    }
    
    compare2(value1:OnepageField, value2:OnepageField): number {
        var section1 = value1.location;
        var section2 = value2.location;
        var seq1 = value1.sequence;
        var seq2 = value2.sequence;
        if(section1==section2){
            return seq1 - seq2;
        }

        return section1 > section2 ? 1: -1;
    }
    
    sortField(){
        // if (this.record.onePageFields && this.record.onePageFields.length > 0) {
        //     this.record.onePageFields.sort(this.compare2);
        // }
    }

    getLocationList(locationValue): string[]{
        return locationValue.split(",");
    }

    addTask() {
        let formTask = new OnepageTemplateFieldTypeConfig();
        if(!this.record.onepageTemplateFieldTypeConfigs){
            this.record.onepageTemplateFieldTypeConfigs=[];
        }
        this.record.onepageTemplateFieldTypeConfigs.push(formTask);
    }
    addDisableEntityFieldId(){
        let formTask = new OnepageTemplateAdminFieldControl();
        if(!this.record.onepageTemplateAdminFieldControls){
            this.record.onepageTemplateAdminFieldControls=[];
        }
        this.record.onepageTemplateAdminFieldControls.push(formTask);
    }
    addDefaultFieldId(){
        let formTask = new DefaultOnePageField();
        if(!this.record.defaultOnePageFields){
            this.record.defaultOnePageFields=[];
        }
        this.record.defaultOnePageFields.push(formTask);
    }

    onFieldTypeConfigChange(){
        console.log(">>>>>>"+JSON.stringify(this.record.onepageTemplateFieldTypeConfigs));
    }
    
    addTaskByDefault(id: string, fieldName: string, fieldType: FieldType){
        let formTask = new OnepageField();
        formTask.fieldId = id;
        formTask.fieldName = fieldName;
        formTask.defaultSystemField = true;
        formTask.fieldType = fieldType;
        // this.maxFieldSeq++;
        // formTask.sequence=this.maxFieldSeq;
        // this.record.onePageFields.push(formTask);
    }

    removeFieldType(task: OnepageTemplateFieldTypeConfig, indexOfelement: number) {
        // var index = this.record.onePageFields.indexOf(task);
        this.record.onepageTemplateFieldTypeConfigs.splice(indexOfelement, 1);
    }

    removeAdminField(task: OnepageTemplateAdminFieldControl, indexOfelement: number) {
        // var index = this.record.onePageFields.indexOf(task);
        this.record.onepageTemplateAdminFieldControls.splice(indexOfelement, 1);
    }

    removeDefaultField(task: DefaultOnePageField, indexOfelement: number){
        this.record.defaultOnePageFields.splice(indexOfelement, 1);
    }
 
 

    onFieldFieldIdChange(task: OnepageField, taskType: string) {
         var val: any = task.fieldId;
         val = val.replace(/^\s*/,"");
         val = val.replace(/\s*$/,"");
         task.fieldId=val.replace(/\s[a-zA-Z]/g,function(match){
            var m2 = match.replace(/\s/g,"");
			return m2.toUpperCase();
		});

    }
    onFieldLocationChange() {
        //  console.log('>>>>>>'+JSON.stringify(this.selectedHtmlTemplate.id));
        //  this.record.htmlTemplateFileName = this.selectedHtmlTemplate.templateName;

    }

    changeSelectedTemplateFile(indexOfDefaultOptions) {
        // const htmltemp = this.defaultHtmlTemplate[indexOfDefaultOptions];

        // this.selectedTemplateFile = htmltemp.htmlTemplateImage;
        // // this.record.templateFileName = htmltemp.templateName;
        // this.templateFieldLocationOptions = this.getLocationList(htmltemp.locationValue);
    }

    trimGap(fieldName: string): void{
        let field = this.workflowForm.controls[fieldName];
        if(field){
            console.log(field);
            field['fieldId']='www';
            document.getElementsByName(fieldName)[0].setAttribute('value','ggg');
        }
    }

    isEmptyTask(): boolean {
        let result = false;//this.record.onePageFields && (this.record.onePageFields.length == 0);
        return result;
    }

    isEmptyTaskConfig(formTask: OnepageField): boolean {
        // this task type no need to check the config.
        // if (formTask && formTask.taskType == 'COMPANY_REGISTER_GEN') {
        //     return false;
        // }
        // if (this.record.onePageFields.find(t => t == formTask) != null) {
        //     return false;//formTask.taskConfig == null;
        // }
        return false;
    }

    deleteDoc(): void{
        let instance = this;
        let txt = 'CONFIRM_TO_DELETE_THE_ONEPAGE_TEMPLATE';
        
        this.translate.get([txt,
        'CONFIRM',
        'CANCEL'])
        .subscribe(res => {
            swal.fire({
                text: res[txt],
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: res.CANCEL,
                confirmButtonText: res.CONFIRM
            }).then(result => {
                if (result.value) {
                       instance.loading = false;
                       instance.record.status='DELETED';
                       this.__delete();
                }
            });
        });
    }

    
    private __delete(): void {
        
        this.mainComponent.enableLoadingMask();
        this.loading = true;

        this.onepageTemplateConfigService.delete(this.record.id)
            .subscribe((response: CommonResponse) => {
                this.mainComponent.disableLoadingMask();
                this.loading = false;

                if(response.content.status=='SUCCESS'){
                    this.translate.get(ModulePathConstant.TEMPLATE_CENTER_MODULE)
                    .pipe(
                        switchMap(typeStr => this.translate.get(AppConstant.DELETE_ONEPAGE_TEMPLATE_SUCCESS))
                    )
                    .subscribe(res => {
                        swal.fire({
                            type: 'success',
                            title: res
                        });
                    });

                    this.router.navigate([ModulePathConstant.ONEPAGE_TEMPLATE_CONFIG_PATH]);
                }else{
                    this.translate.get(ModulePathConstant.TEMPLATE_CENTER_MODULE)
                    .pipe(
                        switchMap(typeStr => this.translate.get(response.content.message))
                    )
                    .subscribe(res => {
                        swal.fire({
                            type: 'error',
                            title: res
                        });
                    });
                }
            }, (error: ErrorResponse) => {
                 this.mainComponent.disableLoadingMask();
                this.loading = false;
            });
    }


    save(): void {

        this.clickSave = true;
        //check form for just clicking save without any input
        for (let key of Object.keys(this.workflowForm.controls)) {
            this.workflowForm.controls[key].markAsDirty();
        }


        if (!this.isValid2Submit) {
            return;
        }

        // var px = this.record.templateFileName.indexOf(".");
        // this.record.templateFileCode = this.record.templateFileName.substring(0, px);

        if (this.workflowForm.valid) {
            //  this.record.companyTemplateLogoImage = this.imgFile;
            // this.record.templateFileName = MapObjectUtil.setOtherLocaleValueAsCurrentLocale(this.record.templateFileName,'en')
            switch (this.action) {
                case 'CREATE':
                    this.create();
                    break
                case 'EDIT':
                    this.update();
                    break;
            }
        }
    }

    private initFormTask() {
        // this.record.onePageFields.forEach(formTask => {
        //     // if (formTask._selectedUsername.length == 0) {
        //     //     this.isValid2Submit = false;
        //     // } else {
        //     //    // formTask.assignUsers = formTask._selectedUsername.join(AppConstant.USER_TASK_ASSIGN_NAME);
        //     // }
        // });
    }

    clickSaveAndDeploy: boolean = false;
    private saveAndDeploy(): void {

        this.clickSaveAndDeploy = true;
        this.save();
        // this.router.navigate([ModulePathConstant.ONEPAGE_TEMPLATE_DEPLOYMENT_PATH, {
        //     id: `ID_${this.record.id}`
        // }]);

        //    this.router.navigate([ModulePathConstant.ONEPAGE_TEMPLATE_DEPLOYMENT_PATH+'/ID_'+this.record.id]);
        
    }

    private create(): void {

        this.mainComponent.enableLoadingMask();
        this.loading = true;

        this.onepageTemplateConfigService.insert(this.record)
            .subscribe(() => {
                this.mainComponent.disableLoadingMask();
                this.loading = false;

                this.router.navigate([ModulePathConstant.ONEPAGE_TEMPLATE_CONFIG_PATH]);

                this.translate.get(ModulePathConstant.TEMPLATE_CENTER_MODULE)
                    .pipe(
                        switchMap(typeStr => this.translate.get(AppConstant.HAS_BEEN_ADDED, { type: typeStr }))
                    )
                    .subscribe(res => {
                        swal.fire({
                            type: 'success',
                            title: res
                        });
                    });
            },
                (error: ErrorResponse) => {
                    this.mainComponent.disableLoadingMask();
                    this.loading = false;
                    from(error.errors)
                        .pipe(
                            mergeMap(error => this.translate.get(error.errorCode)),
                            reduce((acc, value) => acc + value + '<br/>', '')
                        )
                        .subscribe(msg => {

                            this.translate.get(ModulePathConstant.TEMPLATE_CENTER_MODULE)
                                .pipe(
                                    switchMap(typeStr => this.translate.get(AppConstant.FAIL_TO_ADD, { type: typeStr }))
                                )
                                .subscribe(title => {
                                    swal.fire({
                                        type: 'error',
                                        title: title,
                                        html: msg
                                    });
                                });

                        });
                });
    }

    private update(): void {

        this.mainComponent.enableLoadingMask();
        this.loading = true;

        this.onepageTemplateConfigService.update(this.record)
            .subscribe(record => {
                this.record = record;
                this.mainComponent.disableLoadingMask();
                this.loading = false;

                this.router.navigate([ModulePathConstant.ONEPAGE_TEMPLATE_CONFIG_PATH]);

                this.translate.get(ModulePathConstant.TEMPLATE_CENTER_MODULE)
                    .pipe(
                        switchMap(typeStr => this.translate.get(AppConstant.HAS_BEEN_UPDATED, { type: typeStr }))
                    )
                    .subscribe(res => {
                        swal.fire({
                            type: 'success',
                            title: res
                        });
                        
                        if(this.clickSaveAndDeploy){
                            this.router.navigate([ModulePathConstant.ONEPAGE_TEMPLATE_DEPLOYMENT_PATH+'/ID_'+this.record.id]);
                        }
                    });

            },
                (error: ErrorResponse) => {
                    this.mainComponent.disableLoadingMask();
                    this.loading = false;


                    from(error.errors)
                        .pipe(
                            mergeMap(error => this.translate.get(error.errorCode)),
                            reduce((acc, value) => acc + value + '<br/>', '')
                        )
                        .subscribe(msg => {

                            this.translate.get(ModulePathConstant.TEMPLATE_CENTER_MODULE)
                                .pipe(
                                    switchMap(typeStr => this.translate.get(AppConstant.FAIL_TO_UPDATE, { type: typeStr }))
                                )
                                .subscribe(title => {
                                    swal.fire({
                                        type: 'error',
                                        title: title,
                                        html: msg
                                    });
                                });
                        });
                })

    }

    cancel(): void {
        this.router.navigate([ModulePathConstant.ONEPAGE_TEMPLATE_CONFIG_PATH]);
    }


    openItemSelector(formTask: OnepageField) {
        formTask.templateFieldLocationOptions = this.templateFieldLocationOptions;
    }

    onTaskConfigSave(formTask: OnepageField) {
        console.debug('task config finished')
    }


    isFieldNotCompleted(formTask: OnepageField){
        var rx = formTask.sequence && formTask.location && !formTask.fieldType;
        this.isValid2Submit = !rx;
        return rx;
    }


    
    fileLoading: boolean = false;
      
    downloadFile() {
        let item = this.imgFile;
        this.fileLoading = true;
        item._selected = true;
        this.binaryFileService.downloadFile(item.binaryFileId)
            .subscribe(blob => {

                FileSaver.saveAs(blob, item.fileName);
                this.fileLoading = false;
                item._selected = false;
            }, (error: ErrorResponse) => {
                this.fileLoading = false;
                item._selected = false;
                from(error.errors)
                    .pipe(
                        mergeMap(error => this.translate.get(error.errorCode)),
                        reduce((acc, value) => acc + value + '<br/>', '')
                    )
                    .subscribe(msg => {
                        this.translate.get(item.fileName)
                            .pipe(
                                switchMap(typeStr => this.translate.get('FAIL_TO_DOWNLOAD', { type: typeStr }))
                            )
                            .subscribe(title => {
                                toastr.options = {
                                    "closeButton": true,
                                    "positionClass": "toast-bottom-right",
                                    "timeOut": "0",
                                    "extendedTimeOut": "0"
                                }
                                toastr.error(msg, title);
                            });
                    });
            })
    }

    showDownloadButton() {
        if (!this.imgFile) {
            return false;
        }
        return this.imgFile.binaryFileId != null && !(this.imgFile._selected)
    }

    removeDocuments(): void {
        if (!this.imgFile || this.imgFile.fileName == null) {
            return;
        }
        this.imgFile._selected = true;
        this.imgFile = null;
        this.documentFileSelect.nativeElement.value = '';
    }
    public onAttachmentUploadOutput(output: UploadOutput): void {
        if (output.file != null) {
            this.binaryFileApplication = null;
            if (this.imgFile == null) {
                this.imgFile = new BinaryFile();
            }
            this.binaryFileApplication = new ApplicationFile(output.file, null, MAX_DOCUMENT_FILE_SIZE);
            this.binaryFileApplication.readAsBase64((result) => {
                this.imgFile.content = result;
                this.imgFile.fileName = output.file.name;
                this.imgFile.fileSize = output.file.size;
                this.imgFile._fileName = output.file.name;
                this.imgFile._selected = true;
                this.documentFileSelect.nativeElement.value = '';
            })
        }
    }
}
